import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { request } from "@/lib/coachQueries";

/**
 * Master v5 Prompt 23 — Deterministic next step and closed coaching loop.
 * Client-facing "recommended next practice" + coach-facing explainability
 * drill-down/decision hooks.
 */
export function useRecommendationForLayer(workspaceId, layerKey) {
  return useQuery({
    queryKey: ["recommendation", workspaceId, layerKey],
    enabled: !!workspaceId && !!layerKey,
    queryFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/recommendations/${layerKey}`),
  });
}

export function useRecommendationCandidates(workspaceId, recId) {
  return useQuery({
    queryKey: ["recommendation-candidates", workspaceId, recId],
    enabled: !!workspaceId && !!recId,
    queryFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/recommendations/${recId}/candidates`),
  });
}

export function useDecideRecommendation(workspaceId, memberId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ recId, decision, overrideLibId, overrideLibvId, note }) =>
      request(`/api/rehearsal-room/workspaces/${workspaceId}/recommendations/${recId}/decide`, {
        method: "POST",
        body: JSON.stringify({ decision, override_lib_id: overrideLibId ?? null, override_libv_id: overrideLibvId ?? null, note: note ?? null }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["client-record", "recommendations", workspaceId, memberId] });
      qc.invalidateQueries({ queryKey: ["coach-today"] });
    },
  });
}

export function useDismissRecommendation(workspaceId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ recId }) =>
      request(`/api/rehearsal-room/workspaces/${workspaceId}/recommendations/${recId}/outcome`, {
        method: "POST", body: JSON.stringify({ outcome: "dismissed" }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["recommendation", workspaceId] }),
  });
}
